"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (typeof value === 'number') {
    return value;
  }

  if (("" + value).includes('.')) {
    return parseFloat(value);
  }

  return parseInt(value, 10);
};